import { EnvironmentOutlined } from '@ant-design/icons';

import DeliveryPage from '../pages/DeliveryPage';

import { SiteMap } from './index';

export const deliveryRoutes: SiteMap = {
  delivery: {
    title: '배송 관리',
    page: DeliveryPage,
    icon: <EnvironmentOutlined />,
    key: '/delivery',
    children: [
      {
        label: '배송 동선',
        icon: null,
        key: '/delivery/route',
      },
      {
        label: '파트너 관리',
        icon: null,
        key: '/delivery/partners-user',
      },
      {
        label: '배송지 관리',
        icon: null,
        key: '/delivery/spot',
      },
      {
        label: '배송지 지도',
        icon: null,
        key: '/delivery/map',
      },
      {
        label: '패킹표',
        icon: null,
        key: '/delivery/packing-sheet',
      },
      {
        label: '거래명세서',
        icon: null,
        key: '/delivery/invoice',
      },
      {
        label: '기타 인쇄물',
        icon: null,
        key: '/delivery/packing-info-print',
      },
      {
        label: '물류 업무 히스토리',
        icon: null,
        key: '/delivery/task-history',
      },
      {
        label: '배송 실적',
        icon: null,
        key: '/delivery/performance/table',
        role: ['admin'],
      },
    ],
  },
};
